import React from 'react';
import Card from '../../../Shared/Components/Card/Card';

const AiOverviewCard = ({ aiOverview }) => {
    if (!aiOverview || !String(aiOverview).trim()) {
        return null;
    }

    return (
        <Card title="AI Overview">
            <div style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '14px 16px',
                color: '#334155',
                lineHeight: 1.6,
                whiteSpace: 'pre-wrap'
            }}>
                {aiOverview}
            </div>
        </Card>
    );
};

export default AiOverviewCard;